import {
  FormControl,
  FormHelperText,
  InputLabel,
  OutlinedInput,
} from '@material-ui/core';
import React from 'react';

import { makeStyles, Theme } from '@material-ui/core/styles';
import InputMask from 'react-input-mask';
import {
  devePermitirTeclaNumerica,
  filtrarValorNumerico,
  isMascaraNumerica,
} from '../../../../utils/numeric-input';

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    '& .MuiOutlinedInput-root': {
      '&:hover fieldset': {
        borderColor: '#264259',
      },
    },
  },
  labelRoot: {
    backgroundColor: '#fff',
  },
  input: {
    color: theme.palette.primary.main,
  },
  textField: {
    marginBottom: theme.spacing(1),
  },
  control: {
    marginBottom: theme.spacing(1),
  }
}));

const InputMaskText: React.FC = (props: any) => {
  const { mask, ...other }: any = props;

  return <InputMask {...other} mask={props.mask} maskChar=" " />;
}


export default function Text(props): JSX.Element {
  const classes = useStyles();
  const { required, ...inputProps } = props;
  const hasMascaraNumerica = isMascaraNumerica(props.mask);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const filteredValue = filtrarValorNumerico(event.target.value);
    const newEvent = {
      ...event,
      target: {
        ...event.target,
        value: filteredValue,
      },
    } as React.ChangeEvent<HTMLInputElement>;
    if (props.onChange) {
      props.onChange(newEvent);
    }
  };

  const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (!devePermitirTeclaNumerica(event)) {
      event.preventDefault();
    }
    if (props.onKeyDown) {
      props.onKeyDown(event);
    }
  };

  return (
    <FormControl
      fullWidth
      variant="outlined"
      className={classes.control}
    >
      <InputLabel
        classes={{ root: classes.labelRoot }}
        required={required}
        htmlFor={props.id}
      >
        {props.label}
      </InputLabel>
      <OutlinedInput
        inputProps={{
          className: props.disabled ? '' : classes.input,
          mask: props.mask,
          ...(hasMascaraNumerica ? { inputMode: 'numeric' } : {}),
        }}
        inputComponent={InputMaskText}
        {...inputProps}
        {...(hasMascaraNumerica
          ? { onChange: handleChange, onKeyDown: handleKeyDown }
          : {})}
      />
      {props.helperText && (
        <FormHelperText
          style={{ marginLeft: 0 }}
          error={props.error}
        >{props.helperText}
        </FormHelperText>
      )}
    </FormControl>
  );
}
